<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<div class="loader">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
</div>

<style>
    .loader {
        display: flex;
    }

    .loader .dot {
        height: 0.625rem;
        width: 0.625rem;
        background-color: #999;
        animation: typing 2s ease-out infinite;
        margin-right: 6px;
    }

    .loader .dot:nth-child(1) {
        animation-delay: -0.6s;
    }

    .loader .dot:nth-child(2) {
        animation-delay: -0.4s;
    }

    .loader .dot:nth-child(3) {
        animation-delay: -0.2s;
    }


    @keyframes typing {
        0%,
        40%,
        100% {
            transform: initial;
            background-color: #999;
        }
        20% {
            transform: scale(1.3); /* vertikal animieren translatey(-1rem);*/
            background-color: #000; /*gelb: ff0*/
        }
    }
</style>